import React from 'react'
import NumberFormat from 'react-number-format';
import Controls from './Controls';

export default function InputPercent(props) {

    const { name, label, decimalScale = 4, max, value, error=null, helperText=error, onChange, ...other } = props;
    const MAX_VAL = max ? max : 999.9999;
    const withValueLimit = ({ floatValue }) => floatValue <= MAX_VAL;
    return (
        <NumberFormat
            label={label}
            suffix="%"
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={decimalScale}
            fixedDecimalScale="true"
            value={value}
            onValueChange={onChange}
            customInput={Controls.Input}
            isAllowed={withValueLimit}
            {...other}
            {...(error && {error:true,helperText:error})}
            helperText={helperText}
        />
    );
}
